import { ReactElement } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { selectOrganization } from "../../services/organizations/selectors";
import { getShouldRenderUserNavigation } from "../../utils/navigation";

interface Props {
	userNavigation: ReactElement;
	organizationNavigation: ReactElement;
}

export const NavigationType = ({ userNavigation, organizationNavigation }: Props) => {
	const organization = useSelector(selectOrganization);
	const { pathname } = useLocation();
	const shouldRenderUserNavigation = getShouldRenderUserNavigation(pathname, organization.id);

	if (shouldRenderUserNavigation) {
		return userNavigation;
	} else if (organization.id) {
		return organizationNavigation;
	}

	return null;
};
